import initBookmakerRegPanel from 'rp-betting-special-offer';
import initGuiGuide from 'rp-gui-guide';
import popup, { backLink } from 'rp-popup';
import rpUrlNavigationPrefs from 'rp-url-navigation-prefs';
import initAds from './initAds';
import initPrices from './initPrices';

export default {
    beforeRender() {
        initGuiGuide({
            // transform svg to inline
            svg: { polyfill: true },
        });
    },
    afterRender() {
        initBookmakerRegPanel();
        initAds();
        initPrices();
        popup();
        backLink();
        rpUrlNavigationPrefs();
    },
};



// WEBPACK FOOTER //
// ./src/js/rpLibs.js